import Header from '@/pages/layout/components/FrontHeader';
import Wrapper from '@/common/wrapper/Wrapper';
import style from './Login.module.less';
import { Steps, Button, Input, message } from 'antd';
import { useMemo, useState } from 'react';
import { usernameReg, passwordReg } from '@/utils/index';
import layer from '@/utils/layer';
import { getMessageCode, setNewPassword, vaildMessageCode } from '@/service/common';
import { debounce } from 'lodash';
import md5 from 'md5';
import { useRouter } from '@/hooks/hooks';

const ResetPassword = () => {
  let timer: NodeJS.Timer;
  const router = useRouter();
  const steps = ['手机验证', '设置密码'];

  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [saveDisabled, setSaveDisable] = useState(false);

  const isVaildUsername = useMemo(() => {
    return usernameReg.test(username);
  }, [username]);


  const getCode = debounce(() => {
    getMessageCode(username).then(({ data }) => {
      if (data === 1) {
        setCount(() => 60);
        timer = setInterval(() => {
          setCount(c => {
            const newCount = c - 1;
            if (newCount === 0) {
              clearInterval(timer);
            }
            return newCount;
          });
        }, 1000);
      } else if (data === 0) {
        layer.error('发送失败');
      } else if (data === 2) {
        layer.error('请勿频繁操作');
      } else {
        layer.error('已达日发送限额');
      }
    });
  }, 300);

  // 下一步
  const toNextStep = () => {
    if (!isVaildUsername) {
      layer.error('请填写正确的手机号');
      return false;
    }
    if (!code) {
      layer.error('请填写验证码');
      return false;
    }
    vaildMessageCode(username, code).then(({ data }) => {
      if (data) {
        setCurrent(1);
        clearInterval(timer);
      }
    });
  };

  // 重置密码
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const savePassword = () => {
    if (
      password.length < 8 ||
      !passwordReg.test(password)
    ) {
      layer.error('请输入8-20位数字、字母组成的密码');
      return false;
    }
    if (password !== passwordConfirm) {
      layer.error('两次密码输入不一致');
      return false;
    }
    setNewPassword(username, code, md5(password)).then(({ data }) => {
      if (data) {
        setSaveDisable(true);
        message.loading('设置成功', 3, () => {
          router.to('/login');
        });
      }
    });
  };


  return (
    <div>
      <Header bottom hideUserInfo />
      <div className={style.resetPasswordWrapper}>
        <Wrapper type="card" title="重置密码">
          <div className={style.resetPasswordContent}>
            <div className={style.steps}>
              <Steps current={current}>
                {
                  steps.map(i => <Steps.Step key={i} title={i} />)
                }
              </Steps>
            </div>
            {
              current ===0 && (
                <div className={style.form}>
                  <div>
                    <span>手机号码:</span>
                    <Input
                      placeholder="请输入手机号码"
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      maxLength={11}
                    />
                  </div>
                  <div>
                    <span>验证码:</span>
                    <Input
                      placeholder="短信验证码"
                      maxLength={6}
                      value={code}
                      onChange={e => setCode(e.target.value)}
                    />
                    <Button disabled={!isVaildUsername || (count > 0)} onClick={getCode}>
                      {count === 0 ? '获取验证码' : `${count}s后重发`}
                    </Button>
                  </div>
                  <div>
                    <Button type="primary" onClick={toNextStep}>下一步</Button>
                  </div>
                </div>
              )
            }
          </div>
          {/* 密码 */}
          {
            current === 1 && (
              <div className={style.resetPasswordContent}>
                <div className={style.form}>
                  <div>
                    <span>新密码:</span>
                    <Input
                      type="password"
                      placeholder="8-20位，数字与字母的结合"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      maxLength={20}
                    />
                  </div>
                  <div>
                    <span>确认密码:</span>
                    <Input
                      type="password"
                      placeholder="请再次出入新密码"
                      value={passwordConfirm}
                      onChange={e => setPasswordConfirm(e.target.value)}
                      maxLength={20}
                    />
                  </div>
                  <div>
                    <Button type="primary" onClick={savePassword} disabled={saveDisabled}>确认重置</Button>
                  </div>
                </div>
              </div>
            )
          }
        </Wrapper>
      </div>
    </div>
  );
};

export default ResetPassword;
